import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as cursorUsageEvent from '../cursor-usage-event'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: cursorUsageEvent.RESOURCE.payload.dimension.partialId,
      partialId: cursorUsageEvent.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The number of input tokens consumed by this event.',
    isOptional: true,
    name: 'Input Tokens',
    partialId: PartialId.Standard.create('input_tokens'),
    type: core.common.value.types.Intrinsic.Integer,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
